import URL_API_GESTION_CASOS from "@/shared/utils/ApiUrl/GestionCasosApi";
import { HTTP } from "../Http.service";
import type { AboutMeResponse, ChangePasswordRequest, VerifyTwoFARequest } from "@/shared/types/interfaces/GestionCasosApi/Authentication.interface";
import type { PersonalDocumentUser } from "@/shared/types/interfaces/DocumentoPersonalUsuario.interface";

const http = HTTP();

export interface EstablecerEsPrimerInicioSesionRequest{
    idUsuario: number
    estado: boolean
}

export interface EstablecerEsPrimerInicioSesionResponse{
    message: string
}

/**
 * Endpoint para Establecer si es Primer Inicio Sesion del usuario
 */
async function EstablecerEsPrimerInicioSesion(queryString : string): Promise<any> {
    return await http.Patch(`${URL_API_GESTION_CASOS.ESTABLECER_ES_PRIMER_INICIO_SESION}${queryString}`, {});
}

/**
 * Endpoint para Cambiar contraseña del usuario autenticado.
 */
function ChangePassword(data: ChangePasswordRequest):Promise<any>{
    return http.Post(`${URL_API_GESTION_CASOS.CAMBIAR_CONTRASENA_V2}`, {body: data})
}

/**
 * Endpoint para revocar todas las sesiones del usuario autenticado.
 */
function RevokeAllSessions():Promise<any>{
    return http.Post(`${URL_API_GESTION_CASOS.REVOCAR_TODAS_SESIONES_V2}`, {})
}

/**
 * Endpoint para Habilitar la autenticación de dos factores para el usuario.
 */
function EnableTwoFA():Promise<any>{
    return http.Post(`${URL_API_GESTION_CASOS.HABILITAR_2FA_V2}`, {})
}

/**
 * Endpoint para Verificar un código de autenticación de dos factores.
 */
function VerifyTwoFA(data: VerifyTwoFARequest):Promise<any>{
    return http.Post(`${URL_API_GESTION_CASOS.VERIFICAR_2FA_V2}`, {body: data})
}

/**
 * Endpoint para Deshabilitar la autenticación de dos factores.
 */
function DisableTwoFA():Promise<any>{
    return http.Post(`${URL_API_GESTION_CASOS.DESHABILITAR_2FA_V2}`, {})
}

/**
 * Endpoint para regenerar nuevos códigos de respaldo para la autenticación de dos factores.
 */
function BackUpCodesTwoFA():Promise<any>{
    return http.Post(`${URL_API_GESTION_CASOS.REGENERAR_CODIGOS_2FA_V2}`, {})
}

/**
 * Endpoint para generar una imagen de código QR para configurar la autenticación de dos factores.
 */
function QRImageTwoFA():Promise<any>{
    return http.Get(`${URL_API_GESTION_CASOS.GENERAR_QR_2FA_V2}`, {})
}

/**
 * Endpoint para Obtener información del usuario actual.
 */
function AboutMe():Promise<AboutMeResponse>{
    return http.Get(`${URL_API_GESTION_CASOS.ME}`, {})
}

const DocumentosPersonalesService = {
    obtenerDocumentoPersonalUsuario: (idUsuario: number, idTipo: number): Promise<PersonalDocumentUser> => {
       return http.Get(`${URL_API_GESTION_CASOS.OBTENER_DOCUMENTO_PERSONAL_USUARIO}?idUsuario=${idUsuario}&idTipo=${idTipo}`, { });
    },

    obtenerDocumentosPersonalesUsuario: (): Promise<PersonalDocumentUser[]> => {
        return http.Get(`${URL_API_GESTION_CASOS.OBTENER_DOCUMENTOS_PERSONALES_USUARIO}`, {});
    },

    addPersonalFile: (doc: { IdTipo: number, Base64: string, NombreDocumento: string }): Promise<PersonalDocumentUser> => {  
        return http.Post(`${URL_API_GESTION_CASOS.GESTIONAR_DOCUMENTO_PERSONAL_USUARIO}`, { body: doc });        
    },

    updatePersonalFile: (idPersonalDocumentUser: number, updates: { IdTipo: number, Base64: string, NombreDocumento: string }): Promise<PersonalDocumentUser> => {
        return http.Post(`${URL_API_GESTION_CASOS.GESTIONAR_DOCUMENTO_PERSONAL_USUARIO}`, { body: { idPersonalDocumentUser, ...updates } });
    },

    deletePersonalFile: (idPersonalDocumentUser: number): Promise<any> => {
        return http.Delete(`${URL_API_GESTION_CASOS.ELIMINAR_DOCUMENTO_PERSONAL_USUARIO}?idPersonalDocumentUser=${idPersonalDocumentUser}`, {});
    }
};

export {
    EstablecerEsPrimerInicioSesion,
    ChangePassword,
    RevokeAllSessions,
    EnableTwoFA,
    VerifyTwoFA,
    DisableTwoFA,
    BackUpCodesTwoFA,
    QRImageTwoFA,
    AboutMe,
    DocumentosPersonalesService
}
